export enum RR_TOOLTIP_POSITION {
  TOP = 'top',
  LEFT = 'left',
  BOTTOM = 'bottom',
  RIGHT = 'right',
  AUTO = 'auto',
}
